/* ── VERUS NATUS — JS ──────────────────────────────────────────────────────── */

(function () {

  /* ── ENTRY / PASSWORD ────────────────────────────────────────────────────── */
  const passwordInput = document.getElementById('vn-password');
  const submitBtn     = document.getElementById('vn-submit');
  const field         = document.getElementById('vn-field');
  const errorEl       = document.getElementById('vn-error');

  if (passwordInput && submitBtn) {
    // Master password — always unlocks regardless of countdown
    const MASTER_PW = (document.querySelector('meta[name="vn-master-pw"]') || {}).content || 'vn-master-2026';

    // Helper: check if countdown has expired
    const countdownDone = () => {
      const cdEl = document.getElementById('vn-countdown');
      if (!cdEl) return true; // no countdown = open
      const targetStr = cdEl.dataset.target;
      if (!targetStr) return true;
      return new Date(targetStr) <= new Date();
    };

    const attempt = () => {
      const val = passwordInput.value.trim().toLowerCase();
      const correct = (document.querySelector('meta[name="vn-pw"]') || {}).content || 'stray';
      const isMaster = (val === MASTER_PW.toLowerCase());
      const isGeneral = (val === correct.toLowerCase());

      if (isMaster) {
        // Master password: always works, bypasses countdown
        document.cookie = 'vn_access=1; path=/; max-age=86400';
        window.location.href = '/collections/all';
        return;
      }

      if (isGeneral) {
        if (!countdownDone()) {
          // Countdown hasn't ended — reject with a different message
          field.classList.add('is-error', 'is-shaking');
          errorEl.textContent = 'TEMPTATION KILLS';
          passwordInput.value = '';
          setTimeout(() => { field.classList.remove('is-shaking'); }, 500);
          setTimeout(() => { field.classList.remove('is-error'); errorEl.textContent = ''; }, 2500);
        } else {
          // Countdown done — general password works
          document.cookie = 'vn_access=1; path=/; max-age=86400';
          window.location.href = '/collections/all';
        }
        return;
      }

      // Wrong password entirely
      field.classList.add('is-error', 'is-shaking');
      errorEl.textContent = 'ACCESS DENIED.';
      passwordInput.value = '';
      setTimeout(() => { field.classList.remove('is-shaking'); }, 500);
      setTimeout(() => { field.classList.remove('is-error'); errorEl.textContent = ''; }, 2000);
    };

    submitBtn.addEventListener('click', attempt);
    passwordInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') attempt();
    });
  }

  /* ── COUNTDOWN ───────────────────────────────────────────────────────────── */
  const cdEl = document.getElementById('vn-countdown');
  if (cdEl) {
    const targetStr = cdEl.dataset.target;
    const target    = targetStr ? new Date(targetStr) : null;

    const pad = (n) => String(n).padStart(2, '0');

    const tick = () => {
      if (!target) return;
      const now  = new Date();
      const diff = target - now;

      if (diff <= 0) {
        ['d','h','m','s'].forEach(u => {
          const el = document.getElementById('cd-' + u);
          if (el) el.textContent = '00';
        });
        return;
      }

      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      const dEl = document.getElementById('cd-d');
      const hEl = document.getElementById('cd-h');
      const mEl = document.getElementById('cd-m');
      const sEl = document.getElementById('cd-s');

      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    };

    tick();
    setInterval(tick, 1000);
  }

  /* ── CART COUNT UPDATE ───────────────────────────────────────────────────── */
  window.vnUpdateCartCount = function () {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const countEl = document.querySelector('.vn-nav__cart-count');
        if (cart.item_count > 0) {
          if (countEl) {
            countEl.textContent = '(' + cart.item_count + ')';
          } else {
            const cartLink = document.querySelector('.vn-nav__link[href="/cart"]');
            if (cartLink) {
              const span = document.createElement('span');
              span.className = 'vn-nav__cart-count';
              span.textContent = '(' + cart.item_count + ')';
              cartLink.appendChild(span);
            }
          }
        }
      });
  };

  /* ── ADD TO CART (collection page) ──────────────────────────────────────── */
  window.vnAddToCart = function (e, variantId) {
    e.preventDefault();
    e.stopPropagation();

    const btn = e.currentTarget;
    const original = btn.textContent;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(r => r.json())
    .then(() => {
      btn.textContent = 'ADDED.';
      btn.style.background = 'var(--vn-red)';
      btn.style.borderColor = 'var(--vn-red)';
      btn.style.color = 'var(--vn-white)';
      vnUpdateCartCount();
      setTimeout(() => {
        btn.textContent = original;
        btn.style.background = '';
        btn.style.borderColor = '';
        btn.style.color = '';
      }, 1800);
    })
    .catch(() => {
      btn.textContent = 'ERROR.';
      setTimeout(() => { btn.textContent = original; }, 1800);
    });
  };

})();
